import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Affix from './affix';
import { getQrCode } from '@Container/common/client/services/api';

class Share extends React.PureComponent {
    static propTypes = {
        shareInfo: PropTypes.object,
    };

    static defaultProps = {
        shareInfo: {
            url: '',
            title: '',
            summery: '',
            picUrl: '',
        },
    };

    state = {
        qrCodeShow: false,
        left: 0,
        shareBoxTop: 0,
    };

    shareBox = React.createRef();

    componentDidMount() {
        const shareBoxTop = this.shareBox.current.offsetTop;

        this.setState({
            shareBoxTop,
        });
    }

    handleClick = e => {
        const item = e.currentTarget.attributes['data-item'].value;
        const { url, title, summery, picUrl } = this.props.shareInfo;

        if (item === 'sina') {
            window.open(
                `http://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(
                    title,
                )}&summery=${encodeURIComponent(summery)}&pic=${encodeURIComponent(picUrl)}`,
            );
        } else if (item === 'qqzone') {
            window.open(
                `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
                    url,
                )}&title=${encodeURIComponent(title)}&pics=${encodeURIComponent(picUrl)}`,
            );
        }
    };

    handleMouseEnter = e => {
        const item = e.currentTarget.attributes['data-item'].value;

        if (this.qrCode) {
            this.setState({
                qrCodeShow: true,
                left: item === 'wechat' ? 75 : 233,
            });
        } else {
            this.getQrCode(item);
        }
    };

    handleMouseLeave = () => {
        this.setState({
            qrCodeShow: false,
            left: 0,
        });
    };

    getQrCode = async item => {
        const { url } = this.props.shareInfo;

        if (!this.qrCode) {
            const data = await getQrCode(url);

            this.qrCode = data.qrcode_url;
        }

        this.setState({
            qrCodeShow: true,
            left: item === 'wechat' ? 75 : 233,
        });
    };

    render() {
        const { qrCodeShow, left, shareBoxTop } = this.state;
        const { shareInfo } = this.props;

        return (
            <div className={styles.share_box} ref={this.shareBox}>
                <div className={styles.share_bar}>
                    <a className={styles.sina} data-item="sina" onClick={this.handleClick}>
                        微博
                    </a>
                    <a
                        className={styles.wechat}
                        data-item="wechat"
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}>
                        微信好友
                    </a>
                    <a
                        className={styles.cof}
                        data-item="cof"
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}>
                        朋友圈
                    </a>
                    <a className={styles.qqzone} data-item="qqzone" onClick={this.handleClick}>
                        QQ空间
                    </a>
                </div>
                {qrCodeShow ? (
                    <div className={styles.wexin_share} style={{ left: `${left}px` }}>
                        <div className={styles.wx}>
                            <div className={styles.qrCode_box}>
                                <img src={this.qrCode} />
                                <p>
                                    用微信扫描二维码<br />分享至好友和朋友圈
                                </p>
                                <div className={styles.close} onClick={this.handleClose} />
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
                <NoSSR>
                    <Affix content={shareInfo} shareBoxTop={shareBoxTop} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Share);
